const LoadingIcon = () => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 50 50"
      className="dotted-circle-spinner"
    >
      <g fill="currentColor">
        <circle cx="25" cy="5" r="3">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="40" cy="12" r="3" opacity=".8">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="45" cy="25" r="3" opacity=".6">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="40" cy="38" r="3" opacity=".4">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="25" cy="45" r="3" opacity=".3">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="10" cy="38" r="3" opacity=".4">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="5" cy="25" r="3" opacity=".6">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="10" cy="12" r="3" opacity=".8">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </svg>
  )
}

export default LoadingIcon
